import { fetchJson } from '@atlassian/jira-fetch';
import type { BaseUrl, ProjectId } from '@atlassian/jira-shared-types';
import type { ProjectResponse } from './types';

export const fetchProjectUrl = (baseUrl: BaseUrl, projectId: ProjectId, expand: string[]) => {
	const params = expand.length === 0 ? '' : `?expand=${expand.join(',')}`;
	return `/rest/api/2/project/${projectId}${params}`;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	baseUrl: BaseUrl,
	{
		projectId,
		expand,
	}: {
		projectId: ProjectId;
		expand: string[];
	},
): Promise<ProjectResponse> => fetchJson(fetchProjectUrl(baseUrl, projectId, expand));
